import { Any } from "@cede/types";
import { OldTrackingTradingCampaignNames } from "../trade";

export const generateCampaignId = (campaign: string, epoch?: Any) => {
  // Dogami campaign didn't have epoch
  if (
    !epoch ||
    campaign === OldTrackingTradingCampaignNames.DOGAMI ||
    campaign === OldTrackingTradingCampaignNames.LYNEX
  ) {
    return campaign;
  }
  return `${campaign}-${epoch.start.toISOString()}-${epoch.end.toISOString()}`;
};
